import { useEffect, useState } from "react";
import {
  FaTimes,
  FaWhatsapp,
  FaEnvelope,
  FaGift,
} from "react-icons/fa";
import "./BulkOrderPopup.css";

function BulkOrderPopup() {

  const [show, setShow] = useState(false);

  useEffect(() => {

    const timer = setTimeout(() => {
      setShow(true);
    }, 700);

    return () => clearTimeout(timer);

  }, []);

  if (!show) return null;

  return (

    <div className="popup-overlay">

      <div className="bulk-popup">

        <button
          className="popup-close"
          onClick={() => setShow(false)}
        >
          <FaTimes />
        </button>

        <div className="popup-icon">
          <FaGift />
        </div>

        <h2>BULK ORDERS & CUSTOM SCENTS</h2>

        <p>
          Perfect for corporate gifts, events,
          weddings, or branded giveaways.
        </p>

        <ul>
          <li>✔ Customize your scent</li>
          <li>✔ Add your logo or branding</li>
          <li>✔ Bulk pricing available</li>
        </ul>

        <div className="popup-contact">

          <a href="mailto:sahscents@yahoo.com">
            <FaEnvelope />
            sahscents@yahoo.com
          </a>

          <a
            href="https://wa.me/971526103130"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp />
            +971 52 610 3130
          </a>

        </div>

      </div>

    </div>

  );
}

export default BulkOrderPopup;